import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/equipment";

export type listType = {
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
};
export interface list_equipment_type extends listType {

}

export class EquipmentApi extends BaseAPI {
  static getAllEquipment(query?: listType): Promise<AxiosResponse> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static getEquipmentById(id: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/${id}`);
  }

  static createEquipment(body: FormData): Promise<any> {
    return this.api.post(`${path}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static updateEquipment(id: number, body: FormData): Promise<any> {
    return this.api.patch(`${path}/${id}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static deleteEquipment(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
}
